module.exports = __webpack_public_path__ + "img/meme_02.4ebc47e4.jpg";